import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { BudgetsModule } from '@features/budgets/budgets.module';
import { ZeroStateBlockModule } from '@yourcause/common/zero-state-block';
import { ArchiveCycleModalComponent } from './archive-cycle-modal/archive-cycle-modal.component';
import { CycleBudgetSelectorComponent } from './cycle-budget-selector/cycle-budget-selector.component';
import { ProgramCycleModalComponent } from './program-cycle-modal/program-cycle-modal.component';
import { ProgramCyclesComponent } from './program-cycles/program-cycles.component';

@NgModule({
  imports: [
    GCCoreModule,
    BudgetsModule,
    ZeroStateBlockModule
  ],
  declarations: [
    ProgramCyclesComponent,
    ProgramCycleModalComponent,
    ArchiveCycleModalComponent,
    CycleBudgetSelectorComponent
  ],
  exports: [
    ProgramCyclesComponent,
    ProgramCycleModalComponent,
    ArchiveCycleModalComponent,
    CycleBudgetSelectorComponent
  ]
})
export class CyclesModule { }
